<div class="modal-header">
  <button
    type="button"
    class="btn-close"
    (click)="bsModalRef.hide()"
    aria-label="Close"
  >
    <i class="feather x"></i>
  </button>
  <h4 class="modal-title" id="myModalLabel">Update Status</h4>
</div>

<div class="modal-body">
  <div class="loading" *ngIf="loading" style="border-radius: 16px">
    <div class="loader">Loading...</div>
  </div>

  <p>Select the new status:</p>
  <p-dropdown
    [options]="statuses"
    [(ngModel)]="selectedNewStatus"
    optionLabel="label"
    placeholder="Select..."
  >
  </p-dropdown>
</div>

<div class="modal-footer">
  <div class="btn btn-default pull-left" aria-label="Cancel" (click)="cancel()">
    Cancel
  </div>
  <div
    class="btn btn-primary pull-right"
    aria-label="Confirm"
    (click)="confirm()"
    [ngClass]="{ disabled: selectedNewStatus === null }"
  >
    Update Status
  </div>
</div>
